(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeaderLogoOnly extends HTMLElement {
    constructor() {
      super();
      this.lastScrollTop = 0;
      this.scrollThreshold = 8;
      this.revealOffset = 80;
      this.logoHidden = false;
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header') || this.closest('.shopify-section');

      if (!this.header) return;

      this.logo = this.header.querySelector('[data-header-logo]');
      this.predictiveSearch = this.querySelector('predictive-search');

      if (!this.logo) return;

      this.setHeaderHeight();

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.setHeaderHeight.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler);

      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
    }

    setHeaderHeight() {
      if (!this.header) return;

      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    onScroll() {
      if (!this.header) return;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollDifference = Math.abs(scrollTop - this.lastScrollTop);

      if (scrollDifference < this.scrollThreshold) return;

      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden', 'animate');

      if (scrollTop <= this.revealOffset) {
        this.resetLogo();
        this.lastScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.lastScrollTop) {
        this.hideLogo();
      } else {
        this.showLogo();
      }

      this.lastScrollTop = scrollTop;
    }

    hideLogo() {
      if (this.logoHidden) return;

      this.header.classList.add('header-logo-hidden');
      this.header.classList.remove('header-logo-visible', 'shopify-section-header-hidden', 'animate');

      this.logoHidden = true;
    }

    showLogo() {
      this.header.classList.add('header-logo-visible', 'shopify-section-header-sticky');
      this.header.classList.remove('header-logo-hidden', 'shopify-section-header-hidden');

      this.logoHidden = false;
    }

    resetLogo() {
      this.header.classList.remove(
        'header-logo-hidden',
        'header-logo-visible',
        'shopify-section-header-hidden',
        'animate'
      );

      this.logoHidden = false;
    }
  }

  if (!customElements.get('sticky-header-logo-only')) {
    customElements.define('sticky-header-logo-only', StickyHeaderLogoOnly);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-header"]) return;
  try {
    
  class MobileStickyHeader extends HTMLElement {
    constructor() {
      super();
      this.lastScrollTop = 0;
      this.scrollThreshold = 8;
      this.revealOffset = 60;
      this.isHidden = false;
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-mobile-header') || this.closest('.shopify-section');

      if (!this.header) return;

      this.predictiveSearch = this.querySelector('predictive-search');

      this.setHeaderHeight();

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.setHeaderHeight.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler);

      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
    }

    setHeaderHeight() {
      if (!this.header) return;

      document.documentElement.style.setProperty('--mobile-header-height', `${this.header.offsetHeight}px`);
    }

    isMenuOpen() {
      return document.querySelector('.custom-burger.is-open, .menu-drawer[open], details[open] .menu-drawer') !== null;
    }

    onScroll() {
      if (!this.header) return;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (this.isMenuOpen()) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollDifference = Math.abs(scrollTop - this.lastScrollTop);

      if (scrollDifference < this.scrollThreshold) return;

      if (scrollTop <= this.revealOffset) {
        this.reset();
        this.lastScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.lastScrollTop) {
        this.hide();
      } else {
        this.reveal();
      }

      this.lastScrollTop = scrollTop;
    }

hide() {
  if (this.isHidden) return;

  this.header.classList.add('shopify-section-mobile-header-sticky', 'mobile-header-logo-hidden');
  this.header.classList.remove('mobile-header-logo-visible');

  this.isHidden = true;
}

reveal() {
  this.header.classList.add('shopify-section-mobile-header-sticky', 'mobile-header-logo-visible');
  this.header.classList.remove('mobile-header-logo-hidden');

  this.isHidden = false;
}

reset() {
  this.header.classList.remove(
    'mobile-header-logo-hidden',
    'mobile-header-logo-visible',
    'shopify-section-mobile-header-sticky',
    'animate',
    'shopify-section-mobile-header-hidden'
  );

  this.isHidden = false;
}
  }

  if (!customElements.get('mobile-sticky-header')) {
    customElements.define('mobile-sticky-header', MobileStickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secondary-header"]) return;
  try {
    
  class StickySecondaryHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerBounds = {};
      this.headerSection = this.header.querySelector('.header-section')
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.headerSection);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  customElements.define('sticky-secondary-header', StickySecondaryHeader);

  } catch(e) { console.error(e); }
})();
})();
